export const COMPLETED_EVENT = "DOCUSIGN_SIGNATURE_COMPLETED"
export const ENVELOPE_EXPIRED = "DOCUSIGN_ENVELOPE_EXPIRED"